import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { Box, Button, Container, Typography } from '@material-ui/core';
import ErrorIcon from '@material-ui/icons/Error';
import ShieldIcon from '@material-ui/icons/Security';
import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Head, Main, Root, TopAppBarSpacer } from '../components/Shared';
export default function IpRestrictionErrorPage() {
    const history = useHistory();
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const clientIp = query.get('ip') || '不明';
    const clientName = query.get('clientName') || '不明';
    const handleGoHome = () => {
        history.push('/');
    };
    return (_jsxs(Root, { children: [_jsx(Head, { title: "\u30A2\u30AF\u30BB\u30B9\u5236\u9650\u30A8\u30E9\u30FC" }), _jsxs(Main, { children: [_jsx(TopAppBarSpacer, {}), _jsx(Container, { maxWidth: "md", children: _jsxs(Box, { css: styles.container, children: [_jsx(ShieldIcon, { css: styles.icon }), _jsx(Typography, { variant: "h4", component: "h1", css: styles.title, children: "\u30A2\u30AF\u30BB\u30B9\u5236\u9650\u30A8\u30E9\u30FC" }), _jsx(Typography, { variant: "body1", css: styles.message, children: "\u3053\u306EIP\u30A2\u30C9\u30EC\u30B9\u304B\u3089\u306E\u30A2\u30AF\u30BB\u30B9\u306F\u8A31\u53EF\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002" }), _jsxs(Box, { css: styles.ipBox, children: [_jsx(ErrorIcon, { css: styles.errorIcon }), _jsxs(Typography, { variant: "body1", children: [_jsx("strong", { children: "\u3042\u306A\u305F\u306EIP\u30A2\u30C9\u30EC\u30B9\uFF1A" }), " ", clientIp] })] }), _jsxs(Typography, { variant: "body1", gutterBottom: true, children: ["\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u300C", clientName, "\u300D\u306F\u3001\u7279\u5B9A\u306EIP\u30A2\u30C9\u30EC\u30B9\u304B\u3089\u306E\u30A2\u30AF\u30BB\u30B9\u306E\u307F\u3092\u8A31\u53EF\u3057\u3066\u3044\u307E\u3059\u3002"] }), _jsx(Typography, { variant: "body1", gutterBottom: true, children: "\u30A2\u30AF\u30BB\u30B9\u3059\u308B\u306B\u306F\u3001\u8A31\u53EF\u3055\u308C\u305F\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u306B\u63A5\u7D9A\u3059\u308B\u304B\u3001\u7BA1\u7406\u8005\u306B\u9023\u7D61\u3057\u3066IP\u30A2\u30C9\u30EC\u30B9\u3092\u8A31\u53EF\u30EA\u30B9\u30C8\u306B\u8FFD\u52A0\u3057\u3066\u3082\u3089\u3063\u3066\u304F\u3060\u3055\u3044\u3002" }), _jsx(Box, { mt: 3, children: _jsx(Button, { variant: "contained", css: styles.homeButton, onClick: handleGoHome, children: "\u30DB\u30FC\u30E0\u306B\u623B\u308B" }) })] }) })] })] }));
}
const styles = {
    container: css `
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 2rem;
    text-align: center;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    background-color: white;
    margin: 2rem auto;
    max-width: 800px;
  `,
    icon: css `
    font-size: 4rem;
    color: #f44336;
    margin-bottom: 1rem;
  `,
    title: css `
    margin-bottom: 1rem;
    font-weight: bold;
  `,
    message: css `
    margin-bottom: 2rem;
  `,
    ipBox: css `
    background-color: #f5f5f5;
    padding: 1rem;
    border-radius: 4px;
    margin-bottom: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
  `,
    errorIcon: css `
    color: #f44336;
    margin-right: 0.5rem;
  `,
    homeButton: css `
    background-color: #4caf50;
    color: white;
    &:hover {
      background-color: #388e3c;
    }
  `,
    note: css `
    margin-top: 2rem;
    font-size: 0.8rem;
    color: #757575;
  `,
};
